import { render } from "./PopupReading.vue?vue&type=template&id=0c9b76ef&scoped=true"
import script from "./PopupReading.vue?vue&type=script&lang=js"
export * from "./PopupReading.vue?vue&type=script&lang=js"

import "./PopupReading.vue?vue&type=style&index=0&id=0c9b76ef&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9b76ef"]])

export default __exports__